<!--
 * @Description: newNav组件
 * @Author: fal
 * @FilePath: \xhlz_pc\src\project\components\newNav.vue
 * @LastEditTime: 2025-08-16 14:31:04
-->
<template>
  <div class="menu">
    <div class="fix">
      <div class="title" style="padding: 10px">
        <img src="@/assets/logo8.png" style="width: 160px; height: 45px" />
      </div>
      <el-menu
        class="el-menu-vertical-demo"
        background-color="#0B2F59"
        text-color="#fff"
        active-text-color="#fff"
        :default-active="activePath"
        router
        unique-opened
        @open="handleOpen"
        @close="handleClose"
        @select="handleSelect"
      >
        <template v-for="item in navs">
          <el-menu-item v-if="!item.children || item.children.length === 0" :key="item.path" :index="item.path">
            <i :class="'iconfont2 icon2-' + item.icon" v-if="item.icon" style="font-size: 20px; font-weight: 400"></i>

            <i class="iconfont moren" v-else></i>
            <span>{{ item.name }}</span>
          </el-menu-item>
          <el-submenu v-if="item.children && item.children.length > 0" :key="item.path" :index="item.path">
            <template slot="title">
              <i :class="'iconfont2 icon2-' + item.icon" v-if="item.icon" style="font-size: 20px; font-weight: 400"></i>
              <i class="iconfont moren" v-else></i>
              <span>{{ item.name }}</span>
              <span class="badge" v-if="item.badge">{{ item.badge }}</span>
            </template>
            <div v-if="item.children && item.children.length > 0">
              <template v-for="(subItem, subIndex) in item.children">
                <el-menu-item-group v-if="subItem.children.length == 0" :key="subItem.path">
                  <el-menu-item :index="subItem.path">
                    <span>{{ subItem.name }}</span>
                    <span class="badge sub" v-if="subItem.badge">{{ subItem.badge }}</span>
                  </el-menu-item>
                </el-menu-item-group>
                <el-submenu :index="subIndex.toString()" v-else :key="subIndex">
                  <template slot="title">
                    <span slot="title">{{ subItem.name }}</span>
                  </template>
                  <el-menu-item-group :key="subIndex" v-if="subItem.children.length > 0">
                    <el-menu-item v-for="(ssubMenu, ssIndex) in subItem.children" :key="ssIndex" :index="ssubMenu.path">
                      <span>{{ ssubMenu.name }}</span>
                    </el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </template>
            </div>
          </el-submenu>
        </template>
      </el-menu>
    </div>
  </div>
</template>
<script>
import { highlightMap } from './data';
import customerPath from '../utils/customerPath.js';
export default {
  data() {
    return {
      navs: [],
      userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
    };
  },
  props: {
    nav: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    activePath() {
      const path = this.$route.fullPath;

      for (const [key, paths] of Object.entries(highlightMap)) {
        for (const p of paths) {
          const regex = new RegExp(`^${p}($|\\?)`);
          if (regex.test(path)) {
            return key;
          }
        }
      }

      return path;
    },
  },
  mounted() {
    this.init();
    this.$bus.$on('setBadge', () => {
      this.setBadge(this.navs);
    });
  },
  methods: {
    async init() {
      // const navs = sessionStorage.getItem('navs');
      // if (['机械供应商', '材料供应商'].includes(navs)) {
      //   this.navs = supplierNav;
      // } else {
      //   this.navs = await this.getMenu();
      // }
      this.navs = await this.getMenu();

      const currentPath = this.$route.path;
      const isPathInNavs =
        this.navs.some((item) => item.path === currentPath || (item.children && item.children.some((child) => child.path === currentPath))) || customerPath?.includes(currentPath);

      const first = this.navs[0];
      const availablePath = isPathInNavs ? currentPath : first.children && first.children.length > 0 ? first.children[0].path : first.path;

      if (availablePath) {
        this.$router.push(availablePath);
      }

      sessionStorage.setItem('forbread', JSON.stringify(this.navs));
    },
    getMenu() {
      return new Promise((resolve, reject) => {
        this.$request.get('/collective/select/getMenu').then((item) => {
          console.log('item', item);
          let newMenu = this.setChecked(item);
          this.setBadge(newMenu);
          resolve(newMenu);
        });
      });
    },
    // 设置nav预警数量
    setBadge(data) {
      let map = {
        进度预警: 'progress_warning',
        结算预警: 'settlement_warning',
        造价预警: [],
        人员预警: 'person_warning',
        材料预警: 'material_warning',
        机械预警: 'machine_warning',
        成本预警: 'cost_warning',
      };
      if (this.$checkPermission(226)) {
        map.造价预警.push('clear_label_warning');
      }
      if (this.$checkPermission(227)) {
        map.造价预警.push('settlement_warning');
      }
      // 工程预警
      const cur = data.find((item) => item.menu_name == '工程预警');
      const project_id = JSON.parse(sessionStorage.getItem('userInfo'))?.project?.id;
      if (cur && project_id) {
        this.$request.get('/project/warning/warningNum').then((res) => {
          let total = 0;
          (cur.children || []).forEach((item) => {
            if (Array.isArray(map[item.menu_name])) {
              this.$set(
                item,
                'badge',
                map[item.menu_name].reduce((sum, key) => sum + (res[key] || 0), 0)
              );
            } else {
              this.$set(item, 'badge', res[map[item.menu_name]]);
            }
            total += item.badge;
          });
          this.$set(cur, 'badge', total);
        });
      }
    },
    setChecked(tree) {
      tree.forEach((item) => {
        item.name = item.menu_name;
        item.path = item.menu_url;
        if (item.children) {
          this.setChecked(item.children);
        }
      });
      return tree;
    },
    handleOpen(e) {
      console.log(e);
    },
    handleClose(e) {
      console.log(e);
    },
    handleSelect(e) {
      if (this.$route.path !== e) {
        this.$bus.$emit('showBack', false);
      }
      sessionStorage.removeItem('activeTab');
    },
  },
  beforeDestroy() {
    this.$bus.$off('setBadge');
  },
};
</script>
<style lang="less" scoped>
.menu {
  overflow-x: hidden;
}
.el-menu-vertical-demo {
  width: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
}
.el-menu-item i,
.el-submenu i {
  font-size: 16px;
  color: #fff;
  margin-right: 10px;
}

.item {
  /deep/.el-badge__content.is-fixed {
    top: 24px !important;
    right: -5px !important;
  }
}

.title {
  margin-top: 20px;
  margin-left: 16px;
  text-align: left;
  font-weight: bold;
  font-size: 22px;
  letter-spacing: 2px;
}

.fix {
  position: absolute;
  // position: fixed;
  z-index: 99;
  background: #0b2f59;
  height: 100%;
  width: 257px;
}
.el-submenu {
  .badge {
    float: right;
    margin-top: 16px;
    display: inline-block;
    text-align: center;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 50%;
    background: #ff7859;
    margin-right: 24px;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    &.sub {
      margin-right: -30px;
    }
  }
}
.el-menu-item.is-active {
  background: linear-gradient(90deg, rgba(27, 112, 255, 0.4) 0%, rgba(17, 72, 152, 0.4) 100%); // 在背景渐变色中设置透明度
  border-left: 3px solid #409eff;
  .imga {
    display: inline-block;
  }
  .imgg {
    display: none;
  }
}
.el-submenu__title,
.el-menu-item {
  height: 50px;
  line-height: 50px;
  i {
    color: #fff;
    font-weight: 800;
  }
}
.el-menu-item,
.el-submenu {
  border-left: 3px solid transparent;
  .imga {
    display: none;
  }
  img {
    width: 18px;
    margin-right: 10px;
  }
}
// .el-submenu__title:hover,
.el-menu-item:hover {
  background: linear-gradient(90deg, rgba(27, 112, 255, 0.4) 0%, rgba(17, 72, 152, 0.4) 100%);
  border-left: 3px solid #409eff;
  .imga {
    display: inline-block;
  }
  .imgg {
    display: none;
  }
}
</style>
